import { render, staticRenderFns } from "./SurveyFormsTable.vue?vue&type=template&id=34ab64d0&scoped=true"
import script from "./SurveyFormsTable.vue?vue&type=script&lang=js"
export * from "./SurveyFormsTable.vue?vue&type=script&lang=js"
import style0 from "./SurveyFormsTable.vue?vue&type=style&index=0&id=34ab64d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab64d0",
  null
  
)

export default component.exports